import {authenticationConst} from '../constants';
import {authenticationServiceNode, storeServiceNode} from "../services";
import {alertActions} from './alertAction';
import {appLocalStorage} from "../../_helpers/AppConts";
import {getStoreLocal} from "../../_helpers/HNTUtil";

export const authenticationActions = {login, logout, accessStore, leaveStore, clearRedu}

function login(username, password) {
    return dispatch => {
        authenticationServiceNode.login(username, password)
            .then(
                infoLogin => {
                    let {store} = infoLogin;
                    if (store && store.id && store.logo_url) {
                        storeServiceNode.getLogo(store.id, store.logo_url)
                            .then(
                                data => {
                                    infoLogin.store.logo_base64 = data;
                                    localStorage.setItem(appLocalStorage.STORE, JSON.stringify(infoLogin.store));
                                    dispatch({type: authenticationConst.LOGIN_SUCCESS, infoLogin});
                                },
                                err => {
                                    console.error(err.message, err);
                                    dispatch({type: authenticationConst.LOGIN_SUCCESS, infoLogin});
                                }
                            );
                    } else {
                        dispatch({type: authenticationConst.LOGIN_SUCCESS, infoLogin});
                    }
                },
                error => {
                    dispatch({type: authenticationConst.LOGIN_FAILURE, error});
                    dispatch(alertActions.errorApi(error));
                }
            );
    }
}

function logout() {
    return dispatch => {
        authenticationServiceNode.logout()
            .then(
                data => {
                    dispatch({type: authenticationConst.LOGOUT_SUCCESS});
                },
                err => {
                    dispatch({type: authenticationConst.LOGOUT_FAILURE, err});
                    dispatch(alertActions.errorApi(err));
                }
            );
    }
}


function accessStore(storeId) {
    return dispatch => {
        storeServiceNode.get(storeId)
            .then(
                storeAccessed => {
                    dispatch(alertActions.success(`Accessing the store ${storeAccessed.name} successful`));
                    localStorage.setItem(appLocalStorage.STORE, JSON.stringify(storeAccessed));
                    let store = getStoreLocal();

                    if (store && store.id && store.logo_url) {
                        storeServiceNode.getLogo(store.id, store.logo_url)
                            .then(
                                data => {
                                    store.logo_base64 = data;
                                    localStorage.setItem(appLocalStorage.STORE, JSON.stringify(store));
                                },
                                err => {
                                    console.error(err.message, err);
                                })
                            .finally(() => {
                                dispatch({type: authenticationConst.ACCESS_STORE_SUCCESS, storeAccessed: store});
                            });
                    } else {
                        dispatch({type: authenticationConst.ACCESS_STORE_SUCCESS, storeAccessed: store});
                    }
                },
                error => {
                    dispatch({type: authenticationConst.ACCESS_STORE_FAILURE, error});
                    dispatch(alertActions.errorApi(error));
                }
            );
    }
}

function leaveStore() {
    return dispatch => {
        localStorage.removeItem(appLocalStorage.STORE);
        dispatch({type: authenticationConst.LEAVE_STORE_SUCCESS, storeAccessed: getStoreLocal()});
    }
}


function clearRedu() {
    return { type: authenticationConst.CLEAR };
}
